module.exports = {
	"title": "Shipping"
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal.json
// module id = 1579
// module chunks = 4 14